import { VendorHomeScreen } from "@/features/vendor/dashboard";

export default VendorHomeScreen;
